import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import DriverAdditionalDamage from './driver-additional-damage.jsx';

export default class DriversAdditionalDamages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drivers_additional_damages_accounts:  null,
      isLoading: false,
      url: props.url || '/api/v1/portal/drivers/additional-damages',
    };


    this.getDriversAdditionalDamages();
  }

  getDriversAdditionalDamages() {
    let url = this.state.url;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((driversExcessAccountsJson) => {
        this.setState({
          drivers_additional_damages_accounts: driversExcessAccountsJson,
          isLoading: false,
        });
      });
    });
  }

  render() {
    let DriversAdditionalDamages = [];

    if (this.state.drivers_additional_damages_accounts &&
        this.state.drivers_additional_damages_accounts.length > 0) {
        this.state.drivers_additional_damages_accounts.forEach(
          function(i) {
            DriversAdditionalDamages.push(
              <DriverAdditionalDamage
                key={'drivers-additionstowages-'+i.id}
                data={i}
              />);
          }
       );
    }
    return (
      <div>
      {
        this.state.isLoading ?
        (<div className="loading-box">
          <span className="add-loading-text">
            <i className="fa fa-spinner fa-pulse"></i>
          </span>
        </div>) :
          <div>{DriversAdditionalDamages}</div>
      }
      </div>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-drivers-additional-damages')) {
  ReactDOM.render(
    <DriversAdditionalDamages
      url = {"/api/v1/portal/drivers/additional-damages"}
      message_if_none = 'Excessses not found or available for viewing.'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-drivers-additional-damages'
    )
  );
}
